var _rect, _rect2, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurvivingSpouse = function SvgSurvivingSpouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 186,
    y: 54.5,
    fill: "#4B5563",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 234,
    y: 54.5,
    fill: "#4B5563",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M204.354 27.854a.5.5 0 0 0 0-.708l-3.182-3.181a.501.501 0 0 0-.708.707l2.829 2.828-2.829 2.828a.5.5 0 0 0 .708.707zM185 27.5v.5h19v-1h-19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M196 54.5v-5.046a4 4 0 0 1 4-4h16a4 4 0 0 0 4-4V34.5M244 54.5v-5.046a4 4 0 0 0-4-4h-16a4 4 0 0 1-4-4V34.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 27.5,
    r: 8,
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 27.5,
    r: 8,
    fill: "#4B5563"
  })));
};
export default SvgSurvivingSpouse;